import { state as initialState } from './techpacks.model'
import { actions } from './techpacks.actions'
import { mutations } from './techpacks.mutations'
import { getters } from './techpacks.getters'

export default {
  state: initialState,
  actions,
  mutations,
  getters,
  namespaced: true
}
